import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import type { TMetaInfo } from '../types';

const usePageMetaInfo = () => {
  const { groupId, learnerId, managerId, seriesId, moduleId, programId } = useParams();
  const metaInfo = useMemo(
    () => ({ groupId, learnerId, managerId, seriesId, moduleId, programId } as TMetaInfo),
    [groupId, learnerId, managerId, moduleId, programId, seriesId]
  );
  return metaInfo;
};

export default usePageMetaInfo;
